module.exports = __webpack_public_path__ + "images/c6069208859e14cc6128fa02c6a45c435e569844a3b5bafbf25285e714a71564.svg";